import React, { Component } from 'react'

// Externals
import classNames from 'classnames'
import PropTypes from 'prop-types'
import { Typography, withStyles } from '@material-ui/core'
import { Paper } from 'components'
import styles from './styles'

class Analytics extends Component {
  render () {
    const { classes, className, details, ...rest } = this.props

    const rootClassName = classNames(classes.root, className)

    return (
      <Paper
        {...rest}
        className={rootClassName}
      >
        <div className={classes.content}>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
              KPIs
            </Typography>
          </div>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
                Logins
            </Typography>
            <Typography
              className={classes.value}
              variant='body2'
            >{details.logins}
            </Typography>
          </div>

          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
                Signups
            </Typography>
            <Typography
              className={classes.value}
              variant='body2'
            >{details.signups}
            </Typography>
          </div>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
                Shop List
            </Typography>
            <Typography
              className={classes.value}
              variant='body2'
            >{details.shop_list}
            </Typography>
          </div>
          <div className={classes.details}>
            <Typography
              className={classes.title}
              variant='body2'
            >
                Shop Details
            </Typography>
            <Typography
              className={classes.value}
              variant='body2'
            >{details.shop_details}
            </Typography>
          </div>
          {/* </div> */}
        </div>
      </Paper>
    )
  }
}

Analytics.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(Analytics)
